import { Tooltip, TooltipProps } from "@mui/material";

interface MxTooltipNormalProps {
  children: React.ReactNode;
  label: string;
  placement: TooltipProps["placement"];
}

const MxTooltipNormal: React.FC<MxTooltipNormalProps> = ({
  children,
  label,
  placement
}) => {
  return (
    <Tooltip
      title={label}
      placement={placement ?? "bottom"}
      arrow
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: { offset: [0, 0] }
            }
          ]
        },
        tooltip: {
          sx: theme => ({
            bgcolor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            fontSize: "12px",
            fontWeight: 700,
            px: 1.5,
            py: 0.7,
            borderRadius: "6px",
            boxShadow: "none",
            border: 0,
            whiteSpace: "normal"
          })
        },
        arrow: {
          sx: theme => ({
            transform: "translateY(-30px)",
            color: theme.palette.primary.main
          })
        }
      }}
    >
      {children}
    </Tooltip>
  );
};

export default MxTooltipNormal;
